module.exports = __webpack_public_path__ + "static/media/hexagon.d5a3dfaa.svg";